module.exports = __webpack_public_path__ + "static/media/no-customers.1f148eb3.svg";